module.exports = __webpack_public_path__ + "static/media/gloveAnalogies.adf1e6d9.png";